import { toast } from 'react-toastify'
import moment from 'moment';
import FileDownload from 'react-file-download'

import history from '../utils/history'


import { createAxiosInstance, getModificaciones, acceptedFiles, guid } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'



import { displayMessages, uploadFiles } from './common'

import { getDocumento } from './documentos'


export function getSolicitud(id) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		axios.get(`${API_URL}/solicitudes/contratos-anuales/${id}`)
		.then((res) => {
			const solicitud = res.data.solicitud
			dispatch({ type: types.OBTENER_SOLICITUD_CONTRATOANUAL, payload: { solicitud } })
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}



export function displayModalCreateDocumento(show, title, indexDocumento) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = () => axios.get(`${API_URL}/plantillas`)
		Promise.all([fn0()])
		.then(res => {
			const plantillas = res[0].data.data
			dispatch({ type: types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_CONTRATOANUAL, payload: { show, title, indexDocumento, plantillas } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}


export function updateInputs(path, value, id = null, immutable = true) {
	return (dispatch) => {
        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1, payload: { path, value, immutable } })
        fn0(dispatch)
        let entity
		const attribute = path.split('.').slice(-1)[0];
        switch (attribute) {
            case 'fecha_inicio':
            case 'fecha_entrega':
                entity = 'Documento'
                break;
            default:
        }
        if (entity) {
            const fn1 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_CONTRATOANUAL, payload: { id, entity, attribute, value, action: 'edit' } })
            fn1(dispatch)
        }
	}
}

export function createOrUpdateDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn3 = (d) => d(displayModalCreateDocumento(false))
		const solicitud = getState().contratoanual.get('id')

		const data = getState().contratoanual.get('modalCreateDocumento')		

		let documentoNew = data.get('data')
		let documentoOld = data.get('unchanged')
		documentoNew = documentoNew.set('estado', 2)

		const errors = validateDocumento(documentoNew)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = getModificaciones(documentoNew, documentoOld, 'Documento', switchDocumento)	
			dispatch({
				type: types.DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO,
				payload: true
			})		

			axios.put(`${API_URL}/solicitudes/contratos-anuales/${solicitud}`, modificaciones)
				.then(res => {
					dispatch({
						type: types.DESHABILITAR_BOTON_GUARDAR_CREACION_CONTRATO,
						payload: false
					})
					const solicitud = res.data.solicitud						
					const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL, payload: { solicitud } })
					fn2(dispatch)
					fn3(dispatch)
					displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
				})
		}
	}
}





export function showHideModalAddFirmas(show, solicitud) {
    return (dispatch) => {
		const fn0 = d => d({ type: types.MOSTRAR_MODAL_ADICION_FIRMAS, payload: { show, solicitud }});		
        fn0(dispatch)
    }
}


export function uploadFirmasFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png';	
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}

		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1, payload: { path: 'modalAddFirmas.data.file', value: file, immutable: false } })
		fn1(dispatch)

		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1, payload: { path: 'modalAddFirmas.data.icono', value: icon } })
		fn2(dispatch)

	}
}

export function closeDocumento() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn1 = (d) => d(displayModalCreateDocumento(false))

		const data = getState().documentos.get('modalSummary')

		const documentoOld = data.get('unchanged')		
		let documentoNew = data.get('data')
		
		const solicitud = documentoNew.getIn(['solicitude', 'id'])

		let estado

		if (moment(documentoNew.get('fecha_inicio')).isAfter(moment())) {
			estado = 13
		} else {
			estado = 12
		}		
		
		documentoNew = documentoNew.set('estado', estado)

		const file = getState().contratoanual.getIn(['modalAddFirmas', 'data'])

		const modificaciones = getModificaciones(documentoNew, documentoOld, 'Documento', switchDocumento)

		axios.put(`${API_URL}/solicitudes/contratos-anuales/${solicitud}`, modificaciones)
		.then(res => {
			const solicitud = res.data.solicitud						
			const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL, payload: { solicitud } })
			const fn3 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
			const fn4 = (d) => d(getDocumento(documentoOld.get('id')))
			dispatch(uploadFiles(`/files/${solicitud.id}`, [file], [fn1, fn2, fn3, fn4]))
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})


	}
}





export function previewDocumento(id) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {		

		const documento = getState().contratoanual.getIn(['modalCreateDocumento', 'data'])
		const tipo = getState().common.getIn(['enums', 'documentos', 'tipos', `${documento.get('tipo')}`, 'NOMBRE'])

		axios.post(`${API_URL}/solicitudes/contratos-anuales/view/${id}`, {documento}, { responseType: 'arraybuffer' })
		.then(res => {			
			FileDownload(res.data, `PREV-${tipo}.pdf`);
		})
		.catch(err => {			
			const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)))
			const obj = {
				response: {
					data: decodedString,
					status: 422
				}
			}
			displayMessages(dispatch, obj)
		})
	}
}



export function cancelSolicitud() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

	
		const id = getState().contratoanual.get('id')
        const solicitud = getState().contratoanual.get('solicitud').set('estado', 0)


		const errors = validateSolicitud(solicitud)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				attribute: 'estado',
				value: 0,
				action: 'edit'
			})

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				attribute: 'fecha_cancelacion',
				value: moment().format('YYYY-MM-DD'),
				action: 'edit'
			})

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				attribute: 'motivo_cancelacion',
				value: solicitud.get('motivo_cancelacion'),
				action: 'edit'
			})			

			axios.put(`${API_URL}/solicitudes/contratos-anuales/${id}`, modificaciones)
				.then(res => {
					const solicitud = res.data.solicitud						
					const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_CONTRATOANUAL, payload: { solicitud } })
					fn2(dispatch)
					displayMessages(dispatch, { success: 'Los cambios han sido guardados exitosamente' })
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
				})
		}
	}
}



export function renewContrato(result) {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {


		const data = getState().documentos.get('modalSummary')
		const documento = (result == 1) ? data.get('data') : data.get('data').set('estado', 14)
		const solicitud = documento.getIn(['solicitude', 'id'])
		const observaciones = documento.get('motivo_no_renovacion')


		const errors = validateDocumento(documento)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const id = getState().contratoanual.get('id')
			axios.put(`${API_URL}/solicitudes/contratos-anuales/renew/${solicitud}`, { result, observaciones })	
			.then((res) => {
				
				const solicitud = res.data.solicitud	
				const fn1 = d => d({ type: types.OBTENER_SOLICITUD_CONTRATOANUAL, payload: { solicitud } })
				const fn2 = d => d({ type: types.MOSTRAR_MODAL_RESUMEN_DOCUMENTO, payload: { show: false }})
				const fn3 = () => toast.success('La solicitud de renovación ha sido realizada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				const fn4 = (d) => history.push(window.FOLDER + '/solicitudes/abiertas')
				
				fn1(dispatch)
				fn2(dispatch)
				fn3()
				fn4(dispatch)
	
			})
			.catch((err) => {
				displayMessages(dispatch, err)
			})







		}



	}
}




///******* Shared ********///


const validateDocumento = (data) => {

	const errors = []

	if (data.get('estado') == 2 && !data.get('fecha_inicio')) errors.push('El campo fecha inicio es obligatorio')
	if (data.get('estado') == 2 &&  !data.get('plantilla_id')) errors.push('Debe seleccionar una plantilla')
	const firstDay = moment(new Date(new Date().getFullYear(),0,1))
	if (data.get('estado') == 2 &&  moment(data.get('fecha_inicio')).isBefore(firstDay)) errors.push('La fecha de inicio del contrato no debe ser inferior a la fecha de inicio del año')

	if (data.get('estado') == 14 && !data.get('motivo_no_renovacion')) errors.push('El campo motivo no renovación es obligatorio')

	return errors
}


const validateSolicitud = (data) => {
	const errors = []
	if (data.get('estado') == 0 && !data.get('motivo_cancelacion')) errors.push('El campo motivo es obligatorio')
	return errors
}







const switchDocumento = (change, modificacion) => {
    const path = [...modificacion.attribute]
	modificacion.attribute = path[0]

    switch (change.get('op')) {
		case 'add':
			if (modificacion.attribute === 'adjuntos') {
				modificacion.action = 'hidden'
			}
			break
			
        case 'remove':
            break
    }
}






























// WEBPACK FOOTER //
// ./src/actions/contratoanual.js